import React from 'react';
import styled from 'styled-components';
import MotifToggleSwitch from '@ey/motif-react-wrapper/ToggleSwitch';

export default function ToggleSwitch(props) {
	const {id, className, name, title, checked, disabled, hideLabels, onLabel, offLabel, onChange} = props;
	return (
		<StyledMotifToggleSwitch
			id={id}
			className={className}
			name={name}
			title={title}
			checked={checked ?? false}
			disabled={disabled}
			hideLabels={hideLabels}
			onLabel={onLabel}
			offLabel={offLabel}
			onChange={onChange}
		/>
	);
}

const StyledMotifToggleSwitch = styled(MotifToggleSwitch)``;
